import { useEffect } from "react";
import { getToken } from "../../api";
import CircularProgress from "@mui/material/CircularProgress";
import styles from "./auth.module.css";

interface Props {
    logoClicked: boolean;
    setLogoClicked: React.Dispatch<React.SetStateAction<boolean>>;
    appTitleVisible: boolean;
    setAppTitleVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function Auth(props: Props) {
    useEffect(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("user_id");

        // Try to get token from hash fragment (#token=<JWT>) — SSO/magic link flow
        const hash = window.location.hash;
        const search = window.location.search;

        let token: string | null = null;

        // 1. Primary: extract from hash → #token=<JWT>
        if (hash) {
            token = new URLSearchParams(
                hash.startsWith("#") ? hash.slice(1) : hash
            ).get("token");
        }

        // 2. Fallback: extract from query string → ?token=<JWT>
        if (!token && search) {
            token = new URLSearchParams(search).get("token");
        }

        // 3. Legacy fallback: MSAL-style code + session_state
        if (!token) {
            const query = new URLSearchParams(search);
            const code = query.get("code");
            const session = query.get("session_state");
            if (code) {
                callRedirect(`/authRedirect?code=${code}&session_state=${session}#`);
                return;
            }
        }

        if (token) {
            // Remove token from URL to prevent back-button replay
            window.history.replaceState(null, "", window.location.pathname);
            callRedirect(`/authRedirect?token=${token}`);
        }
    }, []);

    const callRedirect = async (payload: string) => {
        try {
            const response = await getToken(payload);
            if (response?.data?.access_token) {
                localStorage.setItem("token", response.data.access_token);
                localStorage.setItem("user_id", response.data.user_id);
                window.location.href = "/";
            }
        } catch (e) {
            console.error("Auth failed:", e);
        }
    };

    return (
        <div className="mt-5" style={{ pointerEvents: "none" }}>
            <div id={`${styles.auth_overlay}`} style={{ textAlign: "center" }}>
                <CircularProgress className={`${styles.auth_loader}`} color="secondary" />{" "}
            </div>
        </div>
    );
}
